// extracted by mini-css-extract-plugin
export default {"root":"styles_root__12GHY","timeBlock":"styles_timeBlock__9sGTq"};